import React, { useState } from "react";
import BackgroundImage from "./../images/orientation_background.png";
import { useNavigate } from "react-router-dom";
import { axiosReqConfig } from "../functions/axiosRequest";
import { API_IP } from "../global_variables";
import "./PlatformOrientation.css";

const PlatformOrientation = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const [formData, setFormData] = useState({
    helpNeeded: [],
    format: "",
    city: "",
    notes: "",
    fullName: "",
    contactMethod: "",
    contactValue: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (value) => {
    let updatedHelp = [...formData.helpNeeded];
    if (updatedHelp.includes(value)) {
      updatedHelp = updatedHelp.filter((item) => item !== value);
    } else {
      updatedHelp.push(value);
    }
    setFormData({ ...formData, helpNeeded: updatedHelp });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const result = await axiosReqConfig(
      `${API_IP}/api/platform-orientation`,
      "post",
      formData,
    );

    setIsSubmitting(false);

    if (result && result !== undefined) {
      setIsSuccess(true);
    } else {
      alert("Failed to submit request. Please try again.");
    }
  };

  return (
    <div className="PO-container">
      <div
        className="PO-hero"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <div className="PO-hero-content">
          <h1 className="PO-title">Platform Orientation</h1>
        </div>
      </div>

      <div className="PO-main-content">
        <div className="PO-intro-section">
          <h2>Free iCare Village Platform Orientation</h2>
          <p>
            A free session to help you understand and use the iCare Village
            platform to access care services. This is not general technology
            support.
          </p>
        </div>

        <div className="PO-form-wrapper">
          <div className="PO-form-container">
            {isSuccess ? (
              <div className="PO-success-card">
                <img
                  src={require("../images/booking_accepted_icon.webp")}
                  alt="Success"
                  className="PO-success-icon"
                />
                <h2>Request Sent Successfully!</h2>
                <p>
                  Thank you, <strong>{formData.fullName}</strong>. We have
                  received your request for a platform orientation. One of our
                  team members will contact you via{" "}
                  <strong>{formData.contactMethod}</strong> shortly to confirm
                  the details.
                </p>
                <button
                  className="PO-submit-btn"
                  onClick={() => navigate("/")}
                  style={{
                    width: "auto",
                    padding: "12px 40px",
                    marginTop: "20px",
                  }}
                >
                  Return to Home
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="PO-form-group">
                  <label className="PO-group-title">
                    1. What would you like help with? (Select all that apply)
                  </label>
                  <div className="PO-options-grid">
                    {[
                      "Booking a care service",
                      "Understanding services and pricing",
                      "Creating or using an account",
                      "Joining an online consultation",
                      "Not sure — I’d like guidance",
                    ].map((item, index) => {
                      const isSelected = formData.helpNeeded.includes(item);
                      return (
                        <div
                          key={index}
                          className={`PO-option-card ${isSelected ? "selected" : ""}`}
                          onClick={() => handleCheckboxChange(item)}
                        >
                          <div
                            className={`PO-checkbox ${isSelected ? "checked" : ""}`}
                          ></div>
                          <span>{item}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="PO-form-group">
                  <label className="PO-group-title">
                    2. Preferred orientation format (Choose one)
                  </label>
                  <p
                    className="PO-form-note"
                    style={{ marginTop: "-5px", marginBottom: "15px" }}
                  >
                    * Online sessions are used only for iCare Village
                    consultations.
                  </p>
                  <div className="PO-options-grid">
                    {[
                      "In-home visit",
                      "Phone call",
                      "Online (video) session",
                    ].map((item, index) => {
                      const isSelected = formData.format === item;
                      return (
                        <div
                          key={index}
                          className={`PO-option-card ${isSelected ? "selected" : ""}`}
                          onClick={() =>
                            handleChange({
                              target: { name: "format", value: item },
                            })
                          }
                        >
                          <div
                            className={`PO-radio ${isSelected ? "checked" : ""}`}
                          ></div>
                          <span>{item}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="PO-form-group">
                  <label className="PO-group-title">3. City or area</label>
                  <input
                    type="text"
                    name="city"
                    className="PO-text-input"
                    placeholder="Example: Victoria, BC"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="PO-form-group">
                  <label className="PO-group-title">
                    4. Anything you’d like us to know? (Optional)
                  </label>
                  <textarea
                    name="notes"
                    className="PO-text-input"
                    rows="3"
                    placeholder="“I’m not very comfortable using websites” or “I tried booking but got stuck”"
                    value={formData.notes}
                    onChange={handleChange}
                  />
                </div>

                <div className="PO-form-group">
                  <label className="PO-group-title">5. Your name</label>
                  <input
                    type="text"
                    name="fullName"
                    className="PO-text-input"
                    placeholder="Full name"
                    value={formData.fullName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="PO-form-group">
                  <label className="PO-group-title">
                    6. How would you like us to contact you?
                  </label>
                  <div className="PO-contact-method-wrapper">
                    <div
                      className={`PO-contact-btn ${formData.contactMethod === "Phone" ? "active" : ""}`}
                      onClick={() =>
                        handleChange({
                          target: { name: "contactMethod", value: "Phone" },
                        })
                      }
                    >
                      Phone
                    </div>
                    <div
                      className={`PO-contact-btn ${formData.contactMethod === "Email" ? "active" : ""}`}
                      onClick={() =>
                        handleChange({
                          target: { name: "contactMethod", value: "Email" },
                        })
                      }
                    >
                      Email
                    </div>
                  </div>

                  {formData.contactMethod && (
                    <input
                      type={
                        formData.contactMethod === "Email" ? "email" : "tel"
                      }
                      name="contactValue"
                      className="PO-text-input"
                      style={{ marginTop: "15px" }}
                      placeholder={
                        formData.contactMethod === "Email"
                          ? "Enter your email address"
                          : "Enter your phone number"
                      }
                      value={formData.contactValue}
                      onChange={handleChange}
                      required
                    />
                  )}
                </div>

                <button
                  type="submit"
                  className="PO-submit-btn"
                  disabled={isSubmitting}
                  style={{ opacity: isSubmitting ? 0.7 : 1 }}
                >
                  {isSubmitting
                    ? "Sending Request..."
                    : "Request Free Orientation"}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformOrientation;
